{
  "error_fields_required": {
    "defaultMessage": "Please fill out the fields below.",
    "description": "Error shown when required fields are empty."
  },
  "error_email_required": {
    "defaultMessage": "Please enter your email address.",
    "description": "Error shown when required email field is empty."
  },
  "error_email_invalid": {
    "defaultMessage": "Please enter a real email address.",
    "description": "Error shown when email submitted is invalid."
  },
  "error_see_attendant": {
    "defaultMessage": "No photos for this account. Please see a photographer or attendant",
    "description": "Error message shown when attempting to log into kiosk"
  },
  "error_scan_band": {
    "defaultMessage": "No photos for this account. Please scan a band that was used at the photo station",
    "description": "Error message shown when attempting to log into kiosk"
  },
  "error_reservation_not_found": {
    "defaultMessage": "Reservation not found.",
    "description": "Error message shown when attempting to log into kiosk"
  },
  "error_coupon_not_found": {
    "defaultMessage": "Discount code not found",
    "description": "Error message for when the coupon code not found"
  },
  "error_coupon_minimum": {
    "defaultMessage": "Cannot apply discount code. Purchase total is below the minimum amount required",
    "description": "Error message for when the coupon code minimum has not been reached"
  },
  "error_coupon_already_used": {
    "defaultMessage": "Cannot apply discount code. This discount has already been applied to your account.",
    "description": "Error message for when the coupon usage has already been used"
  }
}